import { useRef } from 'react';

/**
 * True while a request for a new key is in flight, the first load included.
 * A page flip or a sort refetches the same key, so the numbers behind it do
 * not shimmer. Neither does a live sync refetch, that one has its own label.
 */
export const useIsRefreshing = (key: string, isFetching: boolean): boolean => {
  const settled = useRef<string | undefined>(undefined);
  if (!isFetching) {
    settled.current = key;
  }
  return isFetching && settled.current !== key;
};
